import { Button, HStack, VStack } from '@chakra-ui/react'
import { DestinationTypes } from '@missionlabs/types'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { ESimActivationFlow } from './ESimActivationFlow'

export type AddDeviceESimFields = {
    type: DestinationTypes.eSim
}

export interface AddDeviceESimFormProps {
    onClose: () => void
    onSubmit: (data: AddDeviceESimFields, closeOnSubmit: boolean) => Promise<void>
}

export const AddDeviceESimForm: FC<AddDeviceESimFormProps> = ({ onClose, onSubmit }) => {
    const { t } = useTranslation()

    async function handleSubmit() {
        await onSubmit({ type: DestinationTypes.eSim }, false)
    }

    return (
        <VStack
            h="full"
            spacing="32px"
            align="stretch"
            justify="space-between"
            data-testid="add-device-esim"
        >
            <VStack p="24px" spacing="10px" align="inherit">
                <ESimActivationFlow onSubmit={handleSubmit} />
            </VStack>
            <HStack px="24px" pb="24px" spacing="16px" align="inherit">
                <Button w="full" size="lg" variant="secondary" onClick={onClose}>
                    {t('Cancel')}
                </Button>
            </HStack>
        </VStack>
    )
}
